import { confirmTravelTogether, confirmManageBook, updateInviteStage, fetchInvitedPaxs } from '@/api/passenger'
import { fetchServices } from '@/api/service'
const confirmTravel = (context, params) => {
  return confirmTravelTogether(params).then((response) => {
    return response
  })
}

const confirmManageRoom = (context, params) => {
  return confirmManageBook(params).then((response) => {
    return response
  })
}

const updateInvite = (context, params) => {
  return updateInviteStage(params).then((response) => {
    return response
  })
}
const getInvitedPaxs = (context, params) => {
  return fetchInvitedPaxs(params).then((response) => {
    return response
  })
}

export default {
  confirmManageRoom,
  confirmTravel,
  updateInvite,
  getInvitedPaxs
}
